import { z } from "zod";

import {
  InternalOrganizationDtoSchema,
  OrganizationDtoSchema,
} from "../../../dtos/organizations";

export const GetOrganizationRequestQueryParamSchema = z.object({
  chargeId: z.string().optional(),
  code: z.string().optional(),
});

export type GetOrganizationRequestQueryParamType = z.infer<
  typeof GetOrganizationRequestQueryParamSchema
>;

export const InternalGetOrganizationRequestPathParamSchema = z.object({
  organizationId: z.string().uuid(),
});

export type InternalGetOrganizationRequestPathParamType = z.infer<
  typeof InternalGetOrganizationRequestPathParamSchema
>;

export const GetOrganizationResponseBodySchema = z.object({
  org: OrganizationDtoSchema,
});

export type GetOrganizationResponseBodyType = z.infer<
  typeof GetOrganizationResponseBodySchema
>;

export const GetInternalOrganizationResponseBodySchema = z.object({
  org: InternalOrganizationDtoSchema,
});

export type GetInternalOrganizationResponseBodyType = z.infer<
  typeof GetInternalOrganizationResponseBodySchema
>;
